import { SuccessNotifications } from 'components/Notification';
import React, { FC, useEffect } from 'react';
import { translationKeys, useTranslation } from 'services/localization';
import { trackDisplaySuccessSubscribeBanner } from '../../../../services/userActionEvents';
import { ActionNotificationMessageProps } from '../../types';
import { Text, Stack } from '@atlaskit/primitives';
import { LearnMoreAction } from '../Actions';

const SuccessSubscribeKeys: FC<ActionNotificationMessageProps> = ({ data, onClose }) => {
  const { translate } = useTranslation();

  useEffect(() => {
    trackDisplaySuccessSubscribeBanner();
  }, []);
  return (
    <SuccessNotifications
      title={translate(translationKeys.NOTIFICATION_SUBSCRIBE_MESSAGE_TITLE, { subscriptions: data || '' })}
      onClose={onClose}
      actions={[<LearnMoreAction key={'learn-more'} />]}
    >
      <Stack space='space.100'>
        <Text as='p'>{translate(translationKeys.NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_PRIMARY)}</Text>
        <Text as='p'>{translate(translationKeys.NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_SECONDARY)}</Text>
      </Stack>
      <Text size='small'>{translate(translationKeys.NOTIFICATION_SUBSCRIBE_MESSAGE_BODY_TERTIARY)}</Text>
    </SuccessNotifications>
  );
};

export default SuccessSubscribeKeys;
